import ConversationPage from './src/conversation-page';

export default ConversationPage;
